var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShieldWithCheck01 = function SvgShieldWithCheck01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8 6.98321C16.2818 6.45759 13.9436 5.30318 12 3.63485C10.0564 5.30318 7.71823 6.45759 5.2 6.98321V10.7679C5.2 15.4183 7.85187 19.6439 12 21.6776C16.1481 19.6439 18.8 15.4183 18.8 10.7679V6.98321ZM4.80388 5.83921C4.33646 5.9327 4 6.34311 4 6.81979V10.7679C4 16.0724 7.1402 20.8738 12 23C16.8598 20.8738 20 16.0724 20 10.7679V6.81979C20 6.34311 19.6635 5.9327 19.1961 5.83921L19.1602 5.83204C16.7752 5.35503 14.5613 4.26672 12.7317 2.6813C12.3144 2.31961 11.6856 2.31961 11.2683 2.6813C9.43873 4.26672 7.22477 5.35503 4.83975 5.83204L4.80388 5.83921Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9036 10.444L10.9803 15.8288L7.57574 12.4243L8.42427 11.5757L11.0197 14.1712L16.0964 9.55603L16.9036 10.444Z"
  })));
};
export default SvgShieldWithCheck01;